import { fmt } from 'components/IntlWrapper/IntlWrapper';

import { ReactComponent as Meta } from 'assets/icons/MetaIcon.svg';
import { ReactComponent as FacebookAndInsta } from 'assets/icons/FacebookAndInsta.svg';
import { ReactComponent as Tiktok } from 'assets/icons/Tiktok.svg';
import { ReactComponent as SnapChat } from 'assets/icons/Snapchat.svg';
import { ReactComponent as Twitter } from 'assets/icons/twitter.svg';
import { ReactComponent as GTM } from 'assets/icons/gtm.svg';

export const SOCIAL_PLATFORMS = [
  {
    name: 'meta',
    icon: Meta,
    subIcon: FacebookAndInsta,
    iconClassName: 'br-pixels__meta-icon',
    title: fmt({ id: 'pixels.meta.title' }),
    subtitle: fmt({ id: 'pixels.meta.description' }),
    apiKey: 'fbPixelId',
    objKey: 'fbPixel',
    helpArticleLink:
      'https://bosta.freshdesk.com/en/support/solutions/articles/36000480416-sllr-how-to-connect-meta-pixel-with-sllr-',
    helpArticleLinkAr:
      'https://bosta.freshdesk.com/ar/support/solutions/articles/36000480416-sllr-how-to-connect-meta-pixel-with-sllr-',
    learnMoreLink:
      'https://developers.facebook.com/docs/meta-pixel/?locale=en_US',
    learnMoreLinkAr:
      'https://developers.facebook.com/docs/meta-pixel/?locale=AR',
    videoSrc: 'https://www.youtube.com/embed/5O4-CFQcXD8?si=ULxnlIk_4oygrkTm',
    videoTimestamp: '1.22'
  },
  {
    name: 'snapChat',
    icon: SnapChat,
    iconClassName: 'br-pixels__snapchat-icon',
    title: fmt({ id: 'pixels.snapChat.title' }),
    subtitle: fmt({ id: 'pixels.snapChat.description' }),
    apiKey: 'snapChatPixelId',
    objKey: 'snapChatPixel',
    helpArticleLink:
      'https://bosta.freshdesk.com/en/support/solutions/articles/36000481386-sllr-how-to-connect-snapchat-pixel-with-sllr-',
    helpArticleLinkAr:
      'https://bosta.freshdesk.com/ar/support/solutions/articles/36000481386-sllr-how-to-connect-snapchat-pixel-with-sllr-',
    learnMoreLink:
      'https://forbusiness.snapchat.com/blog/the-snap-pixel-how-it-works-and-how-to-install-it?lang=en-US',
    learnMoreLinkAr:
      'https://forbusiness.snapchat.com/ar/blog/the-snap-pixel-how-it-works-and-how-to-install-it?lang=AR',
    videoSrc: 'https://www.youtube.com/embed/__JtaiV6ezs?si=qE7Xu0_DChIesqqN',
    videoTimestamp: '0.47'
  },
  {
    name: 'tiktok',
    icon: Tiktok,
    title: fmt({ id: 'pixels.tiktok.title' }),
    subtitle: fmt({ id: 'pixels.tiktok.description' }),
    apiKey: 'tiktokPixelId',
    objKey: 'tiktokPixel',
    helpArticleLink:
      'https://bosta.freshdesk.com/en/support/solutions/articles/36000481389-sllr-how-to-connect-tiktok-pixel-with-sllr-',
    helpArticleLinkAr:
      'https://bosta.freshdesk.com/ar/support/solutions/articles/36000481389-sllr-how-to-connect-tiktok-pixel-with-sllr-',
    learnMoreLink: 'https://ads.tiktok.com/help/article/tiktok-pixel?lang=en',
    learnMoreLinkAr: 'https://ads.tiktok.com/help/article/tiktok-pixel?lang=ar',
    videoSrc: 'https://www.youtube.com/embed/4FaLYUZbV2w?si=sWQSWCRGuSP2Mk6o',
    videoTimestamp: '1.00'
  },
  {
    name: 'twitter',
    icon: Twitter,
    iconClassName: 'br-pixels__twitter-icon',
    title: fmt({ id: 'pixels.twitter.title' }),
    subtitle: fmt({ id: 'pixels.twitter.description' }),
    apiKey: 'xPixelId',
    objKey: 'xPixel',
    learnMoreLink:
      'https://business.twitter.com/en/help/campaign-measurement-and-analytics/conversion-tracking-for-websites.html',
    learnMoreLinkAr:
      'https://business.twitter.com/ar/help/campaign-measurement-and-analytics/conversion-tracking-for-websites.html'
  },
  {
    name: 'gtm',
    icon: GTM,
    iconClassName: 'br-pixels__gtm-icon',
    title: fmt({ id: 'pixels.gtm.title' }),
    subtitle: fmt({ id: 'pixels.gtm.description' }),
    modalSubtitle: fmt({ id: 'pixels.gtm.modal_description' }),
    apiKey: 'gtmId',
    objKey: 'gtmPixel',
    learnMoreLink:
      'https://support.google.com/tagmanager/answer/6103576?hl=en&sjid=13036443800796433860-EU',
    learnMoreLinkAr:
      'https://support.google.com/tagmanager/answer/6103576?hl=ar&sjid=13036443800796433860-EU'
  }
];

export const META_CATALOG = {
  name: 'meta_catalog',
  icon: Meta,
  subIcon: FacebookAndInsta,
  iconClassName: 'br-pixels__meta-icon',
  title: fmt({ id: 'pixels.meta_catalog.title' }),
  subtitle: fmt({ id: 'pixels.meta_catalog.description' }),
  apiKey: 'fbPixelId',
  objKey: 'fbPixel',
  helpArticleLink:
    'https://sllr.freshdesk.com/en/support/solutions/articles/36000503725-how-to-connect-and-sync-meta-catalogue-with-sllr',
  helpArticleLinkAr:
    'https://sllr.freshdesk.com/ar/support/solutions/articles/36000503725-how-to-connect-and-sync-meta-catalogue-with-sllr',
  learnMoreLink:
    'https://developers.facebook.com/docs/meta-pixel/?locale=en_US',
  learnMoreLinkAr: 'https://developers.facebook.com/docs/meta-pixel/?locale=AR',
  videoSrc: 'https://www.youtube.com/embed/CCpnNhTv3sc?si=2jt9B2VQbq5eCnbk',
  videoTimestamp: '1.22',
  cardBtnLabel: fmt({
    id: 'pixels.meta_catalog.action'
  })
};

export const KAEML_CALENDER_BOOK_MEETING_LINK =
  'https://docs.google.com/forms/d/e/1FAIpQLScpvaDJWmBh3Paxl6barjOG8gD0KzCpDTdYGwR-7EAWq47oaA/viewform?embedded=true';

export const VERIFY_TOKEN = 'verify_token';
export const PRIVACY_POLICY_URL = 'http://sllr.co/privacy-policy';

export const CONVERSATIONAL_SALES_HELP_ARTICLE =
  'CONVERSATIONAL_SALES_HELP_ARTICLE';

export const CHANGE_CONVERSATIONAL_SALES_HELP_ARTICLE =
  'CHANGE_CONVERSATIONAL_SALES_HELP_ARTICLE';

//data will be updated
export const CONVERSATIONAL_SALES_VIDEO_AND_ARTICLE = {
  MESSENGER: {
    key: 'messenger',
    CONVERSATIONAL_SALES_HELP_ARTICLE: {
      en: 'https://sllr.freshdesk.com/en/support/solutions/articles/36000483156-how-to-connect-facebook-messenger-with-sllr-chat',
      ar: 'https://sllr.freshdesk.com/ar/support/solutions/articles/36000483156-%D9%83%D9%8A%D9%81%D9%8A%D8%A9-%D8%B1%D8%A8%D8%B7-%D8%A7%D9%84%D9%81%D9%8A%D8%B3%D8%A8%D9%88%D9%83-%D9%85%D8%A7%D8%B3%D9%86%D8%AC%D8%B1-%D8%A8%D8%B3%D9%84%D8%B1-%D8%B4%D8%A7%D8%AA'
    },
    CHANGE_CONVERSATIONAL_SALES_HELP_ARTICLE: {
      en: 'https://sllr.freshdesk.com/en/support/solutions/articles/36000483158-sllr-ii-how-to-update-access-token-to-facebook-page',
      ar: 'https://sllr.freshdesk.com/ar/support/solutions/articles/36000483158-%D8%B7%D8%B1%D9%8A%D9%82%D8%A9-%D8%B1%D8%A8%D8%B7-%D9%85%D8%A7%D8%B3%D9%86%D8%AC%D8%B1-%D9%84%D8%B5%D9%81%D8%AD%D8%A9-%D9%81%D9%8A%D8%B3%D8%A8%D9%88%D9%83-%D8%AC%D8%AF%D9%8A%D8%AF%D8%A9-%D8%A8%D8%B3%D9%84%D8%B1-%D8%B4%D8%A7%D8%AA'
    },
    CONVERSATIONAL_SALES_VIDEO: {
      IS_CHANGE: {
        video_url: 'https://www.youtube.com/embed/URX7dV9yhic',
        video_timestamp: '0.45'
      },
      NO_CHANGE: {
        video_url: 'https://www.youtube.com/embed/YVfuYXtNOMM',
        video_timestamp: '4.53'
      }
    }
  },
  WHATSAPP: {
    key: 'whatsApp',
    CONVERSATIONAL_SALES_HELP_ARTICLE: {
      en: 'https://sllr.freshdesk.com/en/support/solutions/articles/36000483156-how-to-connect-facebook-messenger-with-sllr-chat',
      ar: 'https://sllr.freshdesk.com/ar/support/solutions/articles/36000483156-%D8%B3%D9%84%D8%B1-%D9%83%D9%8A%D9%81%D9%8A%D8%A9-%D8%B1%D8%A8%D8%B7-%D8%A7%D9%84%D9%81%D9%8A%D8%B3%D8%A8%D9%88%D9%83-%D9%85%D8%A7%D8%B3%D9%86%D8%AC%D8%B1-%D9%85%D8%B9-%D8%B3%D9%84%D8%B1'
    },
    CHANGE_CONVERSATIONAL_SALES_HELP_ARTICLE: {
      en: 'https://sllr.freshdesk.com/en/support/solutions/articles/36000483158-sllr-ii-how-to-update-access-token-to-facebook-page',
      ar: 'https://sllr.freshdesk.com/ar/support/solutions/articles/36000483158-%D8%B3%D9%84%D8%B1-ii-%D9%83%D9%8A%D9%81%D9%8A%D8%A9-%D8%AA%D8%AD%D8%AF%D9%8A%D8%AB-%D8%AA%D9%88%D9%83%D9%8A%D9%86-%D8%A7%D9%84%D9%88%D8%B5%D9%88%D9%84-%D8%B9%D9%84%D9%89-%D8%B5%D9%81%D8%AD%D8%A9-%D9%81%D9%8A%D8%B3%D8%A8%D9%88%D9%83'
    },
    CONVERSATIONAL_SALES_VIDEO: {
      IS_CHANGE: {
        video_url: 'https://www.youtube.com/embed/URX7dV9yhic',
        video_timestamp: '0.45'
      },
      NO_CHANGE: {
        video_url: 'https://www.youtube.com/embed/b_SXTO4GtfM',
        video_timestamp: '1.50'
      }
    }
  },
  INSTAGRAM: {
    key: 'instagram',
    CONNECT_FB_PAGE: {
      en: 'https://sllr.freshdesk.com/en/support/solutions/articles/36000501002-connecting-instagram-messenger-with-your-sllr-store',
      ar: 'https://sllr.freshdesk.com/ar/support/solutions/articles/36000501002-connecting-instagram-messenger-with-your-sllr-store'
    },
    CONVERSATIONAL_SALES_HELP_ARTICLE: {
      en: 'https://sllr.freshdesk.com/en/support/solutions/articles/36000483156-sllr-how-to-connect-facebook-messenger-with-sllr',
      ar: 'https://sllr.freshdesk.com/ar/support/solutions/articles/36000483156-%D9%83%D9%8A%D9%8[…]%86%D8%AC%D8%B1-%D8%A8%D8%B3%D9%84%D8%B1-%D8%B4%D8%A7%D8%AA'
    },
    CHANGE_CONVERSATIONAL_SALES_HELP_ARTICLE: {
      en: 'https://sllr.freshdesk.com/en/support/solutions/articles/36000483158-sllr-ii-how-to-update-access-token-to-facebook-page',
      ar: 'https://sllr.freshdesk.com/ar/support/solutions/articles/36000483158-%D8%B3%D9%84%D8%B1-ii-%D9%83%D9%8A%D9%81%D9%8A%D8%A9-%D8%AA%D8%AD%D8%AF%D9%8A%D8%AB-%D8%AA%D9%88%D9%83%D9%8A%D9%86-%D8%A7%D9%84%D9%88%D8%B5%D9%88%D9%84-%D8%B9%D9%84%D9%89-%D8%B5%D9%81%D8%AD%D8%A9-%D9%81%D9%8A%D8%B3%D8%A8%D9%88%D9%83'
    },
    CONVERSATIONAL_SALES_VIDEO: {
      IS_CHANGE: {
        video_url: 'https://www.youtube.com/embed/URX7dV9yhic',
        video_timestamp: '0.46'
      },
      NO_CHANGE: {
        video_url:
          'https://www.youtube.com/embed/4FaLYUZbV2w?si=sWQSWCRGuSP2Mk6o',
        video_timestamp: '1.75'
      }
    }
  }
};

export const META_CATALOG_NAME = 'meta_catalog';
